export default {"src":"/_next/static/media/rewind.79838872.svg","height":28,"width":30};